module.exports = __webpack_public_path__ + "static/media/Download-colored.19de1307.svg";